import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledSection = styled.section`
  background-color: ${color('white')};
  padding-top: ${spacing('xl5')};
  padding-bottom: ${spacing('xl4')};

  @media (max-width: ${screen('mdMax')}) {
    padding-top: ${spacing('xl3')};
    padding-bottom: ${spacing('xl3')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  gap: ${spacing('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  @media (max-width: ${screen('lgMax')}) {
    flex-direction: column;
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  max-width: 48rem;
  font-size: ${fontSize('lg')};
  line-height: 1.6;

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
  }

  @media (max-width: ${screen('lgMax')}) {
    margin: ${spacing('lg')} auto 0;
  }

  ${Heading2}::before {
    left: 0;
    transform: unset;
  }

  strong {
    font-weight: ${fontWeight('extraBold')};
  }

  ul {
    padding-left: 1em;
  }

  li {
    list-style: disc;
  }
`;

export const StyledImage = styled.div`
  flex-shrink: 0;
  width: 27.5rem;
  margin: auto;

  @media (max-width: ${screen('mdMax')}) {
    width: 100%;
  }

  img {
    width: 100%;
    display: block;
  }
`;

export const StyledActions = styled.div`
  display: flex;
  gap: ${spacing('lg')} ${spacing('xl')};
  margin-top: ${spacing('xl')};

  @media (max-width: ${screen('mdMax')}) {
    flex-direction: column;
    align-items: center;
  }
`;
